import React, { useState } from "react";
import { ChevronsLeftRight, Quote } from "lucide-react";

export function BeforeAfter({ before, after, beforeLabel, afterLabel }) {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative h-[320px] sm:h-[520px] rounded-3xl overflow-hidden select-none border border-white/10" data-testid="before-after">
      <img src={after} alt={afterLabel} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <img
        src={before}
        alt={beforeLabel}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        draggable={false}
        data-testid="before-image"
      />
      <span className="absolute top-5 left-5 bg-black/70 backdrop-blur text-white text-[11px] font-mono-x tracking-widest px-3 py-1.5 rounded-full uppercase">{beforeLabel}</span>
      <span className="absolute top-5 right-5 bg-yellow-400 text-black text-[11px] font-mono-x font-bold tracking-widest px-3 py-1.5 rounded-full uppercase">{afterLabel}</span>

      <div className="absolute top-0 bottom-0 w-[3px] bg-yellow-400 pointer-events-none" style={{ left: `calc(${pos}% - 1.5px)` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 rounded-full bg-yellow-400 shadow-[0_0_0_8px_rgba(250,204,21,0.25)] flex items-center justify-center">
          <ChevronsLeftRight className="w-6 h-6 text-black" />
        </div>
      </div>

      <input
        type="range"
        min="0"
        max="100"
        step="0.5"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Compare before and after"
        data-testid="before-after-range"
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
      />
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 bg-black/60 backdrop-blur text-white/80 text-xs px-4 py-1.5 rounded-full pointer-events-none">
        Drag to compare
      </div>
    </div>
  );
}

export function ClientQuote({ t }) {
  if (!t) return null;
  return (
    <div className="reveal relative rounded-3xl bg-zinc-900 border border-white/10 p-8 sm:p-12 overflow-hidden" data-testid="project-testimonial">
      <Quote className="absolute -top-4 -right-4 w-40 h-40 text-yellow-400/[0.06]" />
      <div className="flex gap-1 mb-6">
        {[0, 1, 2, 3, 4].map((k) => <span key={k} className="w-2 h-2 rounded-full bg-yellow-400" />)}
      </div>
      <p className="relative text-white text-[22px] sm:text-[28px] leading-snug font-display font-medium tracking-tight">&ldquo;{t.quote}&rdquo;</p>
      <div className="flex items-center gap-4 mt-8">
        <span className="w-12 h-12 rounded-full bg-yellow-400 text-black font-bold flex items-center justify-center">{t.initials}</span>
        <div>
          <div className="text-white font-semibold">{t.name}</div>
          <div className="text-yellow-400 text-sm">{t.role}</div>
        </div>
      </div>
    </div>
  );
}
